import { useParams, Navigate } from "react-router-dom";
import BeatEngine from "@/components/engine/BeatEngine";
import { SIM_CONFIGS } from "@/data/simConfigs";

export default function GenericSim() {
  const { simId } = useParams();
  const config = SIM_CONFIGS[simId];
  if (!config) return <Navigate to="/sections" replace />;
  return <BeatEngine config={config} />;
}
